import { Box, InputAdornment } from "@mui/material";
import React, { useState, useEffect } from "react";
import styles from "./dealerSearchSection.module.scss";
import FormikControl from "../../../../components/formComponents/FormikControl";
import _ from "lodash";
import i18next from "i18next";
import Button from "../../../../components/buttons/Buttons";
import PropTypes from "prop-types";

const DealerSearchSection = (props) => {
  const {
    handleChange,
    searchKeyword,
    count,
    placeholder,
    isBulkneeded,
    isBtnDisabled = false,
    selectedTab = 1,
  } = props;

  const [searchText, setSearchText] = useState("");

  const isSearchEnabled = () => {
    let isSearchActivated = true;
    const dealerListParams = localStorage.getItem('dealerListSearchParams');
    const groupListParams = localStorage.getItem('groupListSearchParams');

    if (_.isEmpty(dealerListParams) && _.isEmpty(groupListParams)) {
      isSearchActivated = false;
    }
    return isSearchActivated;
  }

  useEffect(() => {
    const dealerListParams = JSON.parse(localStorage.getItem('dealerListSearchParams'));
    const groupListParams = JSON.parse(localStorage.getItem('groupListSearchParams'));
    const dealerSearchValue = _.get(dealerListParams, 'SearchTerm', '');
    const groupSearchValue = _.get(groupListParams, 'SearchTerm', '');

    setSearchText(selectedTab === 5 ? groupSearchValue : dealerSearchValue);
  }, [selectedTab]);
  return (
    <Box
      className={styles.searchSectionWrapper}
      data-testid="DealerSearchSection"
    >
      <Box className={styles.searchSection}>
        <Box className={styles.inputBtnWrapper}>
          <FormikControl
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <span className={styles.searchIcon}></span>
                </InputAdornment>
              ),
            }}
            control="textfield"
            type="text"
            hiddenLabel
            id="filled-hidden-label-small"
            name="search"
            variant="filled"
            size="small"
            placeholder={i18next.t(placeholder)}
            className={`input-grp__box ${styles.searchInput}`}
            onChange={(e) => setSearchText(e.target?.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter" || e.key === "enter") {
                handleChange(searchText);
              }
            }}
            value={searchText}
          />
          <Button
            title={"Search"}
            iconStyle={styles.Back}
            buttonType="muibtn-secondary-with-border"
            classList={isSearchEnabled() ? styles.searchButton : ""}
            attriType={"button"}
            withIcon={true}
            handleClick={() => handleChange(searchText)}
            isDisabled={isBtnDisabled}
          />
          <Box>
            <Button
              title={"Clear Search"}
              iconStyle={styles.Back}
              buttonType="muibtn-secondary"
              attriType={"button"}
              withIcon={true}
              handleClick={() => {
                window.location.reload();
                localStorage.removeItem('dealerListSearchParams');
                localStorage.removeItem('groupListSearchParams');
                localStorage.removeItem('dealerSearchSelectedTab');
              }}
            />
          </Box>
        </Box>

        {!isBtnDisabled && !_.isEmpty(searchKeyword) ? (
          <span className={styles.resultCount}>
            {!_.isEmpty(searchText)
              ? i18next.t("No. results are found", {
                count: count,
              })
              : ""}
          </span>
        ) : (
          ""
        )}
      </Box>
      {isBulkneeded ? (
        <Box className={styles.note}>
          {i18next.t("Select minimum 1 items for bulk actions")}
        </Box>
      ) : null}
    </Box>
  );
};
export default DealerSearchSection;

DealerSearchSection.propTypes = {
  handleChange: PropTypes.any,
  searchKeyword: PropTypes.any,
  count: PropTypes.any,
  placeholder: PropTypes.any,
  isBulkneeded: PropTypes.any,
  isBtnDisabled: PropTypes.any,
  selectedTab: PropTypes.any,
};
